export function createBlueprint(blueprint) {
    return blueprint;
}
//# sourceMappingURL=blueprint.js.map